import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PLERI_FACES } from './pleri-ascii';

import './pleri-page-loader.css';

export interface PleriPageLoaderProps {
  label?: string;
  face?: 'random' | 'smile' | 'uwu';
  motion?: 'animated' | 'still';
}

export const PleriPageLoader = ({
  label,
  face = 'random',
  motion = 'animated',
}: PleriPageLoaderProps) => {
  // A loading fallback must render even while translations are loading.
  const { t } = useTranslation('common', { useSuspense: false });
  const [randomFace] = useState<'smile' | 'uwu'>(() =>
    Math.random() < 0.5 ? 'smile' : 'uwu',
  );
  const selectedFace = face === 'random' ? randomFace : face;

  return (
    <section className="pleri-page-loader" data-motion={motion}>
      <div className="pleri-page-loader__art" aria-hidden="true">
        <pre className="pleri-page-loader__face">
          {PLERI_FACES[selectedFace]}
        </pre>
      </div>
      <div className="pleri-page-loader__status" role="status">
        <span className="pleri-page-loader__dot" aria-hidden="true" />
        <span>{label ?? t('loading', { defaultValue: 'Loading...' })}</span>
      </div>
    </section>
  );
};
